import type * as z from 'zod';

import { statusMutationSchema } from '@/_schemas/status-input';

import { aPIKeyQuerySchema } from './api-key-query-schema';
import { environmentMutationSchema } from './environment-schema';

export const aPIKeyMutationSchema = aPIKeyQuerySchema
  .omit({
    created_by: true,
    last_updated_by: true,
    created_at: true,
    updated_at: true,
    created_by_id: true,
    last_updated_by_id: true,
  })
  .extend({
    status: statusMutationSchema,
    environment: environmentMutationSchema,
  });

export type APIKeyMutationSchema = z.infer<typeof aPIKeyMutationSchema>;

export const aPIKeyCreateSchema = aPIKeyMutationSchema.omit({
  id: true,
});

export type APIKeyCreateSchema = z.infer<typeof aPIKeyCreateSchema>;
